import { render, staticRenderFns } from "./mail-v2.vue?vue&type=template&id=bfa91478&scoped=true&"
var script = {}
import style0 from "./mail-v2.vue?vue&type=style&index=0&id=bfa91478&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa91478",
  null
  
)

export default component.exports